import React, { useState , useEffect} from 'react';


import "@fontsource/mulish"; // Defaults to weight 400.


import { makeStyles } from '@mui/styles';

import Pagination from '@mui/material/Pagination';

import { faFileInvoice } from "@fortawesome/pro-light-svg-icons";

import InvoiceItem from './InvoiceItem';
import Filter from './Filter';

import {getFilteredInvoicesX} from './Utils';
import Interpolator from './Interpolator';



const useStyles = makeStyles(theme => ({
 
    maincolumn: {
    fontFamily:'Mulish', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'flex-start',
    alignItems: 'flex-start',  
    marginLeft: '.5em',
    marginTop: '0px',  
    paddingTop: '.5em',  
    fontSize: 12,
    width: '99%',
    height: '500px', 
    overflow: 'auto',
    //backgroundColor: 'lightgray',
    
   },
 
  
  accountHeader: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'flex-start',
    marginTop:  '.5em',
    marginLeft: '.5em',
    //marginBottom: '.1em',
    fontFamily:'Mulish', 
    fontWeight: '200',
    fontSize: '8pt', 
    width: '370px',

},
pagination: {
  marginTop: 5,
}
  


}));



function InvoiceListView(props) {

  const itemsPerPage=10;
  
  var store = require('store')

  const [selectedInvoiceNo, setSelectedInvoiceNo] = useState('');
  const [filter, setFilter] = useState({period: "Alle", paymentStatus: 'Alle'});
  const [page, setPage] = useState(1);
    
  const classes = useStyles();

 
  useEffect(() =>  {  //runs when filters are applied in Filter component   
    // console.log("Filter applied", filter);  
  },[filter]) 


  const selectInvoice = (invoiceNo) => {
    setSelectedInvoiceNo(invoiceNo);    
  }


  const handleChange = (event, value) => {
    setPage(value);
  };
  

  const getNoOfPages =() => {
    return Math.ceil(getFilteredInvoices(props.account.Invoices).length / itemsPerPage);
  }

  const getFilteredInvoices = (invoices) => {

    const filteredInvoices = getFilteredInvoicesX(invoices, filter);

    return filteredInvoices;
        
  }

  const getPaginatedFilteredInvoices = (invoices) => {
    return getFilteredInvoices(invoices).slice((page -1) * itemsPerPage, ((page-1)*itemsPerPage) + itemsPerPage);
  }

  const isFetchingInvoicesChuncked = (continuationTokens, apiId) => {
    return (continuationTokens && continuationTokens[apiId]);    
  }

  return (  

    
    
    
    <div>
      <div className={classes.accountHeader}>ApiId: {props.account.ApiId} &nbsp; Fakturaer: &nbsp; <Interpolator targetNo={props.account.Invoices.length}/></div>
      
      {/* {isFetchingInvoicesChuncked(props.continuationTokens, props.account.ApiId) && <div>fetching...</div>} */}

      <Filter setFilter={setFilter} noOfInvoicesShowing={getFilteredInvoices(props.account.Invoices).length} totalNoOfInvoices={props.account.Invoices.length} isFetchingChunked={isFetchingInvoicesChuncked(props.continuationTokens, props.account.ApiId)} />           
      <Pagination className={classes.pagination} count={getNoOfPages()} page={page} onChange={handleChange} />
      <div className={classes.maincolumn}>                              

        {
          getPaginatedFilteredInvoices(props.account.Invoices).map((o) =>                                               
              <InvoiceItem key={o.invoiceNumber} invoiceJson={o} selectInvoice={selectInvoice} isSelected={selectedInvoiceNo===o.invoiceNumber} 
              value={new Date(o.invoiceDate).toLocaleDateString('no-NO')} icon={faFileInvoice} userName={props.userName} admin={props.admin} />
          )
        }
      </div> 

    </div>
            
 

    

  );
}






export default InvoiceListView;
